import React, { memo, useEffect, useState } from 'react'
import ApiService from '../../services/ApiService';
import { useNavigate } from 'react-router-dom';
import { useSelector } from "react-redux";

function Funds({ forcePaypal }) {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const { userData } = useSelector(state => state.auth);

    const [Funds, setFunds] = useState([]);

    const navigate = useNavigate();

    const getRechargeAmounts = async () => {
        /////////////////// Api call ///////////////////////
        var response = await new ApiService().GET(`/get-recharge-amount`);
        console.log("get-recharge-amount ", response.data);

        if (response.data.status === '1') {
            setFunds(response.data.data);
        }
    };

    const chooseAmount = (amount) => {
        navigate(forcePaypal ? "/paypal-payment" : "/payment", {
            state: {
                payment_type: "recharge",
                amount
            }
        })
    };

    useEffect(() => {
        getRechargeAmounts();
    }, [])


    return (<>
        <div className="add-fund">
            <h2>Outstanding Wallet Balance</h2>
            <ul className="a-f-m">
                <li>${Number(userData.wallet_amount).toFixed(2)}</li>
            </ul>

            <br />
            <h2>Select Amount</h2>
            <p>Please select the amount you want to add to your wallet</p>
            <ul style={{
                display: 'grid',
                gridTemplateColumns: 'repeat(3, 1fr)',
                gap: '24px',
                justifyItems: 'center',
                padding: '0',
                margin: '30px auto',
                maxWidth: '480px',
                listStyle: 'none'
            }}>
                {Funds.map((item, index) => (
                    <li 
                        key={index} 
                        onClick={() => chooseAmount(item.amount)}
                        style={{
                            width: '110px',
                            height: '110px',
                            borderRadius: '50%',
                            border: '1.5px solid #222',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            fontSize: '1.4rem',
                            fontWeight: 'bold',
                            color: '#000',
                            cursor: 'pointer',
                            transition: 'all 0.25s ease',
                            backgroundColor: '#fff',
                        }}
                        onMouseEnter={(e) => {
                            e.currentTarget.style.backgroundColor = '#8ABB45';
                            e.currentTarget.style.borderColor = '#8ABB45';
                            e.currentTarget.style.color = '#fff';
                            e.currentTarget.style.transform = 'scale(1.08)';
                        }}
                        onMouseLeave={(e) => {
                            e.currentTarget.style.backgroundColor = '#fff';
                            e.currentTarget.style.borderColor = '#222';
                            e.currentTarget.style.color = '#000';
                            e.currentTarget.style.transform = 'scale(1)';
                        }}
                    >
                        ${item.amount}
                    </li>
                ))}
            </ul>
        </div>
    </>)
}

export default memo(Funds);